/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as amplitude from '@amplitude/analytics-browser';
import Session from 'supertokens-web-js/recipe/session';
import { signOut as superTokenSignOut } from 'supertokens-web-js/recipe/thirdpartyemailpassword';

import { experiment } from '@fai/friendli-suite/app/init-amplitude';
import client from '@fai/friendli-suite/shared/apollo/base-link';
import { INTERCOM_APP_ID } from '@fai/friendli-suite/shared/intercom/id';

/**
 * @warning sending POST request to "api/auth/signout" should be done first before calling this function
 */
export const resetAllIntegrations = async () => {
  amplitude.reset();

  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
    window.Intercom('boot', { app_id: INTERCOM_APP_ID });
  }

  await client.clearStore();

  await superTokenSignOut();
  Session.signOut();
  experiment.clear();

  return null;
};
